import React from "react"
import CustomDialog from "../Atoms/CustomDialog"
import ButtonMutation from "../Molecules/ButtonMutation"
import { Icon } from "@blueprintjs/core"

const DeleteDialog = ({
  onClose,
  isOpen,
  title,
  variables,
  mutation,
  optimisticResponse,
  update,
  children,
  onError,
  onCompleted,
  refetchQueries = null,
  disabled,
  ...otherProps
}) => {
  return (
    <CustomDialog
      icon={<Icon icon="trash" intent="danger" />}
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      light
      {...otherProps}
      footerRightButton={
        <ButtonMutation
          mutation={mutation}
          variables={variables}
          optimisticResponse={optimisticResponse}
          onError={onError}
          onCompleted={onCompleted}
          update={update}
          dark={false}
          intent="danger"
          icon="trash"
          text="Delete"
          disabled={disabled}
          refetchQueries={refetchQueries}
        />
      }
    >
      {children}
    </CustomDialog>
  )
}

export default DeleteDialog
